/**
 * Drizzle puts the bound values of a failed query in its error message (`Failed query: …\nparams:
 * …`) and on the error as `params`. Those are what was being written: student aliases, billing
 * names, e-mail addresses. The SQL itself is parameterised and safe to keep.
 *
 * No dependencies, so the browser bundle can use it too.
 */
export function redactQueryParams(text: string): string {
  return text.replace(/(\nparams: )[^\n]*/g, '$1[redacted]')
}

const REDACTED_KEYS = new Set(['params'])

/** A serialized error (and its causes) without query values, safe for logs. */
export function redactSerializedError(value: unknown, depth = 0): unknown {
  if (typeof value === 'string') return redactQueryParams(value)
  if (depth > 8 || value === null || typeof value !== 'object') return value
  if (Array.isArray(value)) return value.map((item) => redactSerializedError(item, depth + 1))
  const out: Record<string, unknown> = {}
  for (const [key, field] of Object.entries(value)) {
    out[key] = REDACTED_KEYS.has(key) ? '[redacted]' : redactSerializedError(field, depth + 1)
  }
  return out
}
